var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1249_40345)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1249_40345",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1249_40345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57126 6.57321C9.07174 4.07273 12.4631 2.66797 15.9993 2.66797C19.5356 2.66797 22.927 4.07273 25.4274 6.57321C27.9279 9.0737 29.3327 12.4651 29.3327 16.0013C29.3327 17.7523 28.9878 19.4861 28.3177 21.1037C27.6477 22.7214 26.6656 24.1913 25.4274 25.4294C24.1893 26.6675 22.7195 27.6496 21.1018 28.3197C19.4841 28.9898 17.7503 29.3346 15.9993 29.3346C14.2484 29.3346 12.5146 28.9898 10.8969 28.3197C9.27923 27.6496 7.80937 26.6675 6.57126 25.4294C5.33314 24.1913 4.35102 22.7214 3.68096 21.1037C3.01089 19.4861 2.66602 17.7523 2.66602 16.0013C2.66602 12.4651 4.07077 9.0737 6.57126 6.57321ZM15.9993 5.33464C13.1704 5.33464 10.4573 6.45844 8.45688 8.45883C6.45649 10.4592 5.33268 13.1723 5.33268 16.0013C5.33268 17.4021 5.60858 18.7891 6.14463 20.0833C6.68068 21.3774 7.46638 22.5533 8.45688 23.5438C9.44737 24.5343 10.6233 25.32 11.9174 25.856C13.2115 26.3921 14.5986 26.668 15.9993 26.668C17.4001 26.668 18.7872 26.3921 20.0813 25.856C21.3754 25.32 22.5513 24.5343 23.5418 23.5438C24.5323 22.5533 25.318 21.3774 25.8541 20.0833C26.3901 18.7891 26.666 17.4021 26.666 16.0013C26.666 13.1723 25.5422 10.4592 23.5418 8.45883C21.5414 6.45844 18.8283 5.33464 15.9993 5.33464ZM14.666 12.0013C14.666 11.2649 15.263 10.668 15.9993 10.668H16.0127C16.7491 10.668 17.346 11.2649 17.346 12.0013C17.346 12.7377 16.7491 13.3346 16.0127 13.3346H15.9993C15.263 13.3346 14.666 12.7377 14.666 12.0013ZM13.3327 16.0013C13.3327 15.2649 13.9296 14.668 14.666 14.668H15.9993C16.7357 14.668 17.3327 15.2649 17.3327 16.0013V20.0013C18.0691 20.0013 18.666 20.5983 18.666 21.3346C18.666 22.071 18.0691 22.668 17.3327 22.668H15.9993C15.263 22.668 14.666 22.071 14.666 21.3346V17.3346C13.9296 17.3346 13.3327 16.7377 13.3327 16.0013Z",
    fill: "#020617"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1249_40345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/info_outline.ade25c7e19f6e54538307ec7e44e84f1.svg";
export { ForwardRef as ReactComponent };